import { render, staticRenderFns } from "./ConflictionStep.vue?vue&type=template&id=70f56077&scoped=true&lang=html&"
import script from "./ConflictionStep.vue?vue&type=script&lang=ts&"
export * from "./ConflictionStep.vue?vue&type=script&lang=ts&"
import style0 from "./ConflictionStep.vue?vue&type=style&index=0&id=70f56077&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f56077",
  null
  
)

export default component.exports